export default "__VITE_ASSET__BJB0qklH__"